import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import { KlaviyoState } from '../reducers/klaviyo.reducer';

export const getKlaviyoState = createSelector(fromFeature.getShopifyState, state => state.klaviyo);

export const getKlaviyoSubscribedProductIds = createSelector(getKlaviyoState, (state: KlaviyoState) => state.productIds);
export const getKlaviyoEmail = createSelector(getKlaviyoState, (state: KlaviyoState) => state.email);

export const isSubscribed = createSelector(getKlaviyoState, (state: KlaviyoState, productId: string) =>
  state.productIds.includes(productId)
);

export const getKlaviyoSubscribedProductIdsLoading = createSelector(getKlaviyoState, (state: KlaviyoState) => state.loading);
export const getKlaviyoSubscribedProductIdsLoaded = createSelector(getKlaviyoState, (state: KlaviyoState) => state.loaded);
